<section class="section white-100" *ngIf="bankingData">
  <div class="section-container">
    <div class="product-blog-container">
      <ng-container>
        <div class="product-blog-row">
          <div
            class="product-blog padd-48-tr0l"
            *ngFor="
              let card of bankingData?.cards;
              let odd = odd;
              let i = index
            "
            [ngClass]="
              i === 0
                ? 'moonstone-100'
                : i === 1
                  ? 'pink-100'
                  : i === 2
                    ? 'blue-100'
                    : ''
            "
          >
            <div (click)="navigateToVertoFX(card?.fields?.link)">
              <div class="product-blog-subheading mar-b-16">
                {{ card?.fields?.tags?.fields?.tagText }}
                <img
                  loading="lazy"
                  [src]="card?.fields?.iconImage?.fields?.file?.url"
                  alt=""
                />
              </div>
              <div class="product-blog-heading mar-b-16" [innerHTML]="
                card?.fields?.richTextTitle | toHtml
              ">
              </div>
              <p class="product-blog-description">
                {{ card?.fields?.description?.content[0]?.content[0]?.value }}
              </p>
            </div>
            <figure>
              <img
                loading="lazy"
                src="{{ card?.fields?.imageicon?.fields?.file?.url }}"
                class="wid-full"
                alt=""
              />
            </figure>
          </div>
          <div class="product-blog-video video-pro">
            <video
              width="100%"
              height="100%"
              #videoPlayer
              class="myvid"
              [src]="videoUrl"
              (play)="onPlay()"
              (pause)="onPause()"
              controls
              [poster]="videoThumbnail"
            >
              <source [src]="videoUrl" type="video/mp4" />
            </video>
            <div
              class="play-button ico-play"
              *ngIf="!isPlaying"
              (click)="playVideo(videoPlayer)"
            ></div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</section>
